// Default `scroll` for every antd <Table>. `x: true` gives the table
// `width: auto; min-width: 100%`: on desktop it fills its card and cell text
// wraps exactly as before, and only once the columns can't shrink any further
// (phones) does the table scroll inside its card instead of pushing the page
// sideways. ("max-content" was tried and stops cell text wrapping, which put a
// scrollbar on desktop tables that used to fit.)
export const TABLE_SCROLL = { x: true };
